import React from "react";
import "./SettingsNewMainbox.css";

function Mainbox() {
  return <div className="settingsnewmainbox"></div>;
}

export default Mainbox;
